import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { GetSearchItemByItemType, SearchItemByTypeParameter, SearchItemByTypeResult } from "@tSurya/Services/SearchItemByTypeService";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type GetSearchItemParameter = HasOnSuccess<SearchItemByTypeResult> & SearchItemByTypeParameter & HasOnError;

type HandlerType = CustomApiHandler<GetSearchItemParameter, SearchItemByTypeResult>;

export const PopulateApiParameter: HandlerType = props =>{
    props.apiParameter = props.parameter
}

export const RequestDataFromApi: HandlerType = async props =>{
    try{
        props.apiResult = (await GetSearchItemByItemType(props.apiParameter)) as SearchItemByTypeResult
    }
    catch(error){
        if(isApiError(error) && error.status === 400){
           props.parameter.onError?.(error.errorJson.message);
        }
        throw error;
    }
}

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const SearchItemByItemType = createHandlerChainRunner(chain, "SearchItemByItemType");
export default SearchItemByItemType;